/**
 * @generated SignedSource<<d336e019dc6dc7ca00649ccc3790c666>>
 * @relayHash 86d400b5a8e9db65fe9467afc59e2e19
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86d400b5a8e9db65fe9467afc59e2e19

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type setTodoEmployeeInput = {
  clientMutationId?: string | null | undefined;
  employeeId?: string | null | undefined;
  todoId: string;
};
export type TodoMutations_SetEmployeeMutation$variables = {
  input: setTodoEmployeeInput;
};
export type TodoMutations_SetEmployeeMutation$data = {
  readonly setTodoEmployee: {
    readonly todo: {
      readonly employee: {
        readonly " $fragmentSpreads": FragmentRefs<"EmployeeFatQuery_data">;
      } | null | undefined;
    };
  } | null | undefined;
};
export type TodoMutations_SetEmployeeMutation = {
  response: TodoMutations_SetEmployeeMutation$data;
  variables: TodoMutations_SetEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoMutations_SetEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoEmployeePayload",
        "kind": "LinkedField",
        "name": "setTodoEmployee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployeeFatQuery_data"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoMutations_SetEmployeeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoEmployeePayload",
        "kind": "LinkedField",
        "name": "setTodoEmployee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "86d400b5a8e9db65fe9467afc59e2e19",
    "metadata": {},
    "name": "TodoMutations_SetEmployeeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2bc8ab545c48d33a7ea14862530dd7b2";

export default node;
